"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MatchOperator = (function () {
    function MatchOperator() {
    }
    return MatchOperator;
}());
exports.MatchOperator = MatchOperator;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-materialize/dist/media/models/matchOperator.js
// module id = ./node_modules/ng2-materialize/dist/media/models/matchOperator.js
// module chunks = vendor